import { useInfiniteQuery } from '@tanstack/react-query'
import { api, PaginatedItemsResponse } from '../services/api'

export const useRecentlyAddedItems = () => {
  return useInfiniteQuery<PaginatedItemsResponse>({
    queryKey: ['recently-added-items'],
    queryFn: ({ pageParam = 1 }) => api.getRecentlyAddedItems(pageParam as number),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      return lastPage.hasMore ? lastPage.page + 1 : undefined
    },
  })
}